import React, {Component} from 'react';
import PropTypes from 'prop-types';

import KeyboardSelectionListener from './KeyboardSelectionListener';
import './PlaceHolder.css';
/*
    A "PlaceHolder" is a slot where a robot can go.
    These used to be visibile elements, but we've replaced that with background images.
    Now these are mostly just targets for click/keyboard events.
*/

export default class PlaceHolder extends Component {
    render() {
        const {
            on_select,
            has_focus,
            focus_child_ref_func,
        } = this.props;

        return <div
            className="PlaceHolder PlaceHolder-click-target"
            ref={focus_child_ref_func}
            onClick={on_select}
            style={{outline: has_focus ? '6px solid orange' : 'none'}}
        >
            {has_focus ? <KeyboardSelectionListener on_select={on_select} /> : null}
        </div>
    }
}
PlaceHolder.propTypes = {
    on_select: PropTypes.func,

    has_focus: PropTypes.bool,

    // One of the elements rendered by PlaceHolder is "focusable"
    // this is a function to pass to the ref of that element
    focus_child_ref_func: PropTypes.func,

    // these effectively map to specific colors
    // we should really turn this into one 'color' prop
    is_hovered: PropTypes.bool,
    is_error: PropTypes.bool,
    is_playing: PropTypes.bool,
    is_correct: PropTypes.bool,

    // default true
    // make sure to set false if you want an immediate color change
    should_transition_to_current_color: PropTypes.bool,
}
PlaceHolder.defaultProps = {
    has_focus: false,
    should_transition_to_current_color: true,
}



// WEBPACK FOOTER //
// ./src/PlaceHolder.js